import { useSearchParams, Link } from "react-router-dom";
import { RotateCcw } from "lucide-react";
import { SiteFooter } from "@/components/SiteFooter";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const jobId = params.get("job_id");
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen bg-obsidian text-white flex flex-col">
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mb-4">
            No charge. No hard feelings.
          </h1>
          <p className="text-slate-400 text-lg mb-8">
            Your watermarked preview is still waiting for you — the jingle doesn't expire.
          </p>
          {jobId ? (
            <Link
              to={`/jingle-preview/${jobId}`}
              data-testid="cancel-back-to-preview"
              className="inline-flex items-center gap-2.5 bg-gradient-to-r from-gold to-[#FB8500] text-black font-extrabold px-8 py-4 rounded-xl hover:scale-105 transition-transform"
            >
              <RotateCcw className="h-4 w-4" /> Back to my jingle
            </Link>
          ) : (
            <Link to="/" data-testid="cancel-back-home" className="text-gold underline">Back home</Link>
          )}
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
